import styled, { css } from "styled-components";
import { parseCSS } from "scripts/FunctionsBundle";

// ################################ INTERFACES & PROPS ################################
type _Base = import("@utils/ClassTypes")._Base;
// GlobalFooter => Rename all instances to use
type GlobalFooterProps = {} & _Base;

// ################################ RENDERING COMPONENT ################################
const _GlobalFooter = (props: GlobalFooterProps) => {
  return (
    <footer className={props.className}>
      Elaborado por{" "}
      <a href="mailto:brianwoolfolk@hotmail.com">Brian Woolfolk</a>. WhatsApp:{" "}
      <a href="tel:6621844819">662 184 4819</a>.
    </footer>
  );
};

// ################################ STYLES ################################
const GlobalFooter = styled(_GlobalFooter).attrs(
  (props: GlobalFooterProps): GlobalFooterProps => {
    return { ...props };
  }
)`
  ${(props) => css`
    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################
export default GlobalFooter;
